import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

const NotFoundPage = (): JSX.Element => (
  <Layout menuItems={[]}>
    <SEO title="404: Side finnes ikke" />
    <h1>404</h1>
    <p>Denne siden finnes ikke</p>
  </Layout>
);

export default NotFoundPage;
